import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

const container = document.getElementById('root');

const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// react-snap injects prerendered HTML — hydrate instead of full client render
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(
    <React.StrictMode>{app}</React.StrictMode>
  );
}
